import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { selectUserState, selectFaqState } from "../../selectors/application";
import PrimaryButton from "../../elements/primary-button";
import Textarea from "../../elements/textarea";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import api from "../../utils/api";

import "./style.scss";

const Helpful = ({ rendering, fields, match, user, faq }) => {
  const lang = match.params.lang;
  const { headingBody, headingType, yes, no, inputLabel, inputWarningMessage, inputMaxLength, submit, submittedMessageHeadingBody, submittedMessageHeadingType, submittedMessageBody, contentIds, category, backgroundColor, paddingAboveTop, paddingAboveBottom } = fields;

  const helpfulClassNames = classNames("helpful", "padding-top-" + paddingAboveTop.fields.phrase.value || "default", "padding-bottom-" + paddingAboveBottom.fields.phrase.value || "default");

  const [yesSelected, setYesSelected] = useState(false),
    [noSelected, setNoSelected] = useState(false),
    [yesLogged, setYesLogged] = useState(false),
    [noLogged, setNoLogged] = useState(false),
    [showInput, setShowInput] = useState(false),
    [showSubmit, setShowSubmit] = useState(false),
    [submitted, setSubmitted] = useState(false),
    [messageIsMissing, setMessageIsMissing] = useState(false),
    [inputValue, setInputValue] = useState(),
    yesNoClassNames = classNames("yes-no", {
      "yes-selected": yesSelected,
      "no-selected": noSelected
    }),
    inputClassNames = classNames("input", {
      show: showInput
    }),
    submitClassNames = classNames("submit", {
      show: showSubmit
    }),
    submittedClassNames = classNames("submitted", {
      show: submitted
    }),
    toggleYes = isYes => {
      let dataLayer = window.dataLayer || [];
      if (!submitted) {
        setNoSelected(!isYes);
        setYesSelected(isYes);
        setShowInput(!isYes);
        setShowSubmit(!isYes);
        if (isYes && !yesLogged) {
          setYesLogged(true);
          submitForm(true);
          dataLayer.push({
            eventCategory: "feedback form",
            eventAction: "feedback given",
            eventLabel: "yes"
          });
        }
        if (!isYes && !noLogged) {
          setNoLogged(true);
          submitForm(false);
          dataLayer.push({
            eventCategory: "feedback form",
            eventAction: "feedback given",
            eventLabel: "no"
          });
        }
      }
    },
    submitForm = (rating, isSumbitMessage) => {
      if (rating === true || (isSumbitMessage && inputWarningMessage && inputValue && inputValue.length)) {
        const body = {
          url: window.location.href,
          articlePublicNumber: contentIds.value ? contentIds.value.split(";") : faq.contentIds ? faq.contentIds.split(";") : null,
          category: category ? category.fields.key.value : faq.category,
          language: lang === "en" ? "en-us" : lang,
          email: user ? user.email : "anonymous",
          rating: rating ? 1 : 0,
          comments: inputValue
        };
        api.articles.comments(null, body);
        setSubmitted(true);
        setShowInput(false);
        setShowSubmit(false);
      } else if ((rating === false && isSumbitMessage === false) || isSumbitMessage === true) {
        setMessageIsMissing(true);
      }
    };

  let backgroundStyle = {};
  if (backgroundColor) {
    backgroundStyle = {
      background: backgroundColor.fields.phrase.value
    };
  }

  return (
    <div className={helpfulClassNames} datasourceid={rendering.dataSource} style={backgroundStyle}>
      {headingBody?.value && (
        <div className="heading">
          <Heading
            {...{
              type: headingType,
              html: headingBody
            }}
          />
        </div>
      )}
      <div className={yesNoClassNames}>
        {yes && (
          <PrimaryButton
            {...{
              ...yes,
              isDisabled: submitted,
              iconName: {
                value: {
                  alt: yes.fields.iconName.value.alt || '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"> <path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" /></svg>'
                }
              },
              buttonText: yes.fields.buttonText.value,
              colorScheme: yes.colorScheme || {
                fields: { phrase: { value: "outline-white" } }
              },
              callback: () => {
                toggleYes(true);
              }
            }}
          />
        )}
        {no && (
          <PrimaryButton
            {...{
              ...no,
              isDisabled: submitted,
              iconName: {
                value: {
                  alt: no.fields.iconName.value.alt || '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"> <path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" /></svg>'
                }
              },
              buttonText: no.fields.buttonText.value,
              colorScheme: no.colorScheme || {
                fields: { phrase: { value: "outline-white" } }
              },
              callback: () => {
                toggleYes(false);
              }
            }}
          />
        )}
      </div>
      <div className={inputClassNames}>
        <Textarea
          {...{
            label: inputLabel?.value,
            warningMessage: inputWarningMessage?.value,
            maxLength: Number(inputMaxLength?.value) || 400,
            onChange: event => {
              setInputValue(event.target.value.length ? event.target.value : undefined);
            },
            onFocus: event => {
              setMessageIsMissing(false);
            },
            showError: inputWarningMessage && messageIsMissing
          }}
        />
      </div>

      {submit && (
        <div className={submitClassNames}>
          <div className="button-container">
            <PrimaryButton
              {...{
                ...submit,
                iconName: {
                  value: {
                    alt: submit.fields.iconName.value.alt || '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"> <path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" /></svg>'
                  }
                },
                buttonText: submit.fields.buttonText.value,
                colorScheme: submit.colorScheme || {
                  fields: { phrase: { value: "outline-green" } }
                },
                callback: event => {
                  submitForm(false, true);
                }
              }}
            />
          </div>
        </div>
      )}
      <div className={submittedClassNames}>
        <div className="message-container">
          {submitted && submittedMessageHeadingBody?.value && (
            <Heading
              {...{
                type: submittedMessageHeadingType,
                html: submittedMessageHeadingBody
              }}
            />
          )}
          {submitted && submittedMessageBody?.value && (
            <BodyText
              {...{
                html: submittedMessageBody.value,
                className: submittedMessageBody.className || "body"
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: selectUserState(state),
  faq: selectFaqState(state)
});

Helpful.propTypes = {
  fields: PropTypes.shape({
    headingBody: PropTypes.object,
    headingType: PropTypes.object,
    yes: PropTypes.object,
    no: PropTypes.object,
    inputLabel: PropTypes.object,
    inputWarningMessage: PropTypes.object,
    inputMaxLength: PropTypes.object,
    submit: PropTypes.object,
    submittedMessageHeadingBody: PropTypes.object,
    submittedMessageHeadingType: PropTypes.object,
    submittedMessageBody: PropTypes.object
  })
};

Helpful.defaultProps = {
  fields: {
    submit: {
      colorScheme: "green-outline"
    }
  }
};
export default withRouter(connect(mapStateToProps)(Helpful));
